import { Component, HostListener, OnInit } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { JhiLanguageService } from '../core-utils';
import { UpperCasePipe } from '@angular/common';
import { NavbarMessageEvent } from '../model/navbar-message.event';

@Component({
    selector: 'jhi-languange-selector',
    standalone: true,
    imports: [
        NgSelectModule,
        FormsModule,
        UpperCasePipe
    ],
    templateUrl: './languange-selector.component.html',
    styleUrl: './languange-selector.component.scss'
})
export class LanguangeSelectorComponent implements OnInit {

    currentLang: string;
    languages = [
        { code: 'en', label: 'English', flag: '🇺🇸' },
        { code: 'es', label: 'Español', flag: '🇪🇸' },
        { code: 'fr', label: 'Français', flag: '🇫🇷' },
        { code: 'pt', label: 'Portuguese', flag: '🇵🇹' }
    ];

    constructor(private languangeService: JhiLanguageService) { }

    ngOnInit(): void {
        this.currentLang = this.languangeService.getCurrentLanguage();
        this.languangeService.changeLanguage(this.currentLang);
    }

    changeLanguage(lang: any): void {
        const langKey = lang.code;
        this.currentLang = langKey;
        this.languangeService.changeLanguage(langKey);
        const message: NavbarMessageEvent = {
            updateContentMargins: true
        };
        window.parent.postMessage(message, '*');
    }

    // Global shortcut: Cmd/Ctrl + Shift + L  => cycle language
    @HostListener('window:keydown', ['$event'])
    onGlobalKeydown(event: KeyboardEvent): void {
        const key = (event.key || '').toLowerCase();
        const isShortcut = (event.ctrlKey || event.metaKey) && event.shiftKey && key === 'l';
        if (!isShortcut) {
            return;
        }

        // Don’t steal shortcuts while typing
        const target = event.target as HTMLElement | null;
        const tag = (target?.tagName || '').toLowerCase();
        const isTypingTarget =
            tag === 'input' ||
            tag === 'textarea' ||
            (target?.isContentEditable ?? false);

        if (isTypingTarget) {
            return;
        }

        event.preventDefault();
        this.cycleLanguage();
    }

    private cycleLanguage(): void {
        const codes = this.languages.map(l => l.code);
        const currentIdx = Math.max(0, codes.indexOf(this.currentLang));
        const nextIdx = (currentIdx + 1) % codes.length;
        const nextCode = codes[nextIdx];

        this.currentLang = nextCode;
        this.languangeService.changeLanguage(nextCode);

        const message: NavbarMessageEvent = { updateContentMargins: true };
        window.parent.postMessage(message, '*');
    }





}
